import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    paddingBottom: 50,
  },
  checkbox: {
    width: "120%",
    padding: 5,
  },
  checkboxText: {
    fontSize: "$image_option_text_size",
    fontFamily: "$image_option_text_style",
  },
  checkboxIcon: {
    fontSize: "$image_option_icon_size",
  },
  optionContainer: {
    alignItems: "center",
    justifyContent: "space-around",
    backgroundColor: "$option_card",
    borderColor: "$option_card_outline",
    borderWidth: 1,
    margin: 3,
    paddingHorizontal: 5,
    paddingVertical: 5,
    width: 200,
  },
  image: {
    width: "18vmax",
    height: "11vmax",
    maxWidth: 150,
    maxHeight: 92,
  },
});
